export const PASSWORD_STRENGTH = ['weak', 'weak', 'medium', 'medium', 'strong'];

export const DEFAULT_PASSWORD_STRENGTH = -1;
